// Module
var code = `<div class="modal fade" id="saveTeamManagementWarningModal" tabindex="-1" role="dialog" data-bind="showModal: show">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" data-bind="click: clear">
                    <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title" data-bind="label: 'cc_P_TEAM_MNGMNT_LOSE_CHANGES_TITLE'"></h4>
            </div>
            <div class="modal-body" style="padding-top: 15px;">
                <div class="alert alert-warning" role="alert" style="margin-bottom: 0px;">
                    <span class="fa fa-exclamation-triangle"></span>
                    <span data-bind="label: 'cc_P_TEAM_MNGMNT_LOSE_CHANGES_CONFIRM'"></span>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" data-bind="label:'Save', click: save"></button>
                <button type="button" class="btn btn-default" data-dismiss="modal" data-bind="click: clear, label: 'cc_P_RESET'"></button>
            </div>
        </div>
    </div>
</div>`;
// Exports
module.exports = code;